<header class="dialog-title">
  @if (isListMode()) {
    <span>{{ 'driver.list' | translate }}</span>
  } @else {
    <span>{{ 'driver.assign' | translate }}</span>
  }
</header>

<div class="box-add-search">
  @if (canEdit()) {
    <button mat-button class="app-button primary" (click)="onAddDriver()">
      <span>{{ 'action.add' | translate }}</span>
    </button>
  }
  <app-search (searchChange)="search.set($event)"></app-search>
</div>

@if (drivers().length > 0) {
  <div class="box-table margin-top-8">
    <app-driver-list-table
      [drivers]="filteredDrivers()"
      [isListMode]="isListMode()"
      [canEdit]="canEdit()"
      [lastSelectedUnitName]="lastSelectedUnitName()"
      (driverEdit)="onEditDriver($event)"
      (driverHistoryOpen)="onOpenHistory($event)"
      (driverAssign)="onAssignDriver($event)"
      (driverDelete)="onDeleteDriver($event)">
    </app-driver-list-table>
  </div>
} @else {
  <div class="container-message">
    {{ 'message.error.nothing-found' | translate }}
  </div>
}

<div class="flex flex-justify-center">
  <button mat-button class="app-button primary" (click)="onClosePage()">{{ 'action.close' | translate }}</button>
</div>
